export type ExpiryLevel = "expired" | "critical" | "warning" | "ok" | "none";

export function daysUntilExpiry(expiryDate: string | null): number | null {
    if (!expiryDate) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDate + "T00:00:00");
    const diff = expiry.getTime() - today.getTime();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function getExpiryLevel(expiryDate: string | null): ExpiryLevel {
    const days = daysUntilExpiry(expiryDate);
    if (days === null) return "none";
    if (days < 0) return "expired";
    if (days <= 2) return "critical";
    if (days <= 7) return "warning";
    if (days <= 14) return "ok";
    return "ok";
}

export function formatExpiryLabel(expiryDate: string | null): string {
    const days = daysUntilExpiry(expiryDate);
    if (days === null) return "No expiry";
    if (days < 0) return `Expired ${Math.abs(days)}d ago`;
    if (days === 0) return "Expires today";
    if (days === 1) return "Expires tomorrow";
    return `${days}d left`;
}

export function formatDate(date: string | null): string {
    if (!date) return "";
    const d = new Date(date + "T00:00:00");
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function toDateInputValue(date: string | null | undefined): string {
    if (!date) return "";
    return date.slice(0, 10);
}

export function formatDiaryDate(date: Date = new Date()): string {
    const formatted = new Intl.DateTimeFormat("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric",
    }).format(date);
    return formatted.toUpperCase();
}

export function todayDateInputValue(): string {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function debounce<T extends (...args: Parameters<T>) => void>(fn: T, ms: number): T {
    let timer: ReturnType<typeof setTimeout>;
    return ((...args: Parameters<T>) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    }) as T;
}
